import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { stationRouteHasUnsavedStationsChangeAtom } from "@ryde/shared";

import { StationRouteEditTopInfoContainerStyled } from "./station-route.styled";

export const StationRouteEditTopInfoContainer: FC = () => {
  const { t } = useTranslation();
  const stationRouteHasUnsavedDistancesChange = useRecoilValue(
    stationRouteHasUnsavedStationsChangeAtom,
  );

  return (
    <StationRouteEditTopInfoContainerStyled>
      {stationRouteHasUnsavedDistancesChange && (
        <div className="info_item">
          <p>* {t(`stationRoute.STATION_ORDER_CHANGE_DETECTED`)}</p>
        </div>
      )}
    </StationRouteEditTopInfoContainerStyled>
  );
};
